angular.module("autoremind.templates").directive("templateUpload", [
    "Upload",
    "logger",
    "templateService",
    "$interval",
    "dialogs",
    "$timeout",
    "$window",
    "eventSharingService",
    function (Upload, logger, templateService, $interval, dialogs, $timeout, $window, eventSharingService) {
        return {
            restrict: "E",
            templateUrl: "app/admin/templates/templates-upload.html",
            link: function (scope, elem, attr) {
                scope.templateService = templateService;
                scope.viewModel = {
                    tmpFile: null,
                    loadingIndicator: {
                        refCount: 0,
                        state: false,
                    },
                    formModel: {
                        file: null,
                        isUserCustomTemplate: false,
                        isMapToUser: false,
                        filePath: angular.isDefined(scope.template.templateFileRef)
                            ? scope.template.templateFileRef
                            : "",
                        templateType: angular.isDefined(scope.template.templateType)
                            ? scope.template.templateType
                            : "communications",
                        communicationsCategoryId: angular.isDefined(scope.template.communicationsCategoryId)
                            ? scope.template.communicationsCategoryId
                            : "",
                        templateDisplayName: angular.isDefined(scope.template.templateDisplayName)
                            ? scope.template.templateDisplayName
                            : "",
                        mediaTypes: {
                            isEmail: true,
                            isSms: true,
                            isVoice: true,
                        },
                        templateName: angular.isDefined(scope.template.templateName)
                            ? scope.template.templateName
                            : "",
                        language: angular.isDefined(scope.template.language)
                            ? scope.template.language
                            : "en-us",
                        fileName: "",
                        isSystemMaster: false,
                        mediaTypesJSON: {
                            media: [
                                {
                                    // "device" : "email|smtp1|0",
                                    templateFragment: "mailcontent",
                                    type: "email",
                                },
                                {
                                    // "device" : "sms|infobip|0",
                                    templateFragment: "smscontent",
                                    type: "sms",
                                },
                                {
                                    // "device" : "voice|pnova|0",
                                    templateFragment: "voicecontent",
                                    type: "voice",
                                },
                            ],
                        },
                        templateDefaultContent: angular.isDefined(scope.template.templateDefaultContent)
                            ? scope.template.templateDefaultContent
                            : {},
                        imageModel: {},
                        templateEditedModel: null,
                    },
                    uploadingModel: {
                        fileLoadProgress: 0,
                        isFileUploading: false,
                        isFileUloaded: false,
                        isUploadError: false,
                    },
                    checkingModel: {
                        interval: null,
                        fileCheckProgress: 0,
                        isFileChecking: false,
                        isValidError: false,
                    },
                    prevFileName: "",
                    isFileNameExist: false,
                    isTemplateNameExist: false,
                    isTemplateAssignedToUser: false,
                    checkFileNameExisting: {
                        refCount: 0,
                        state: false,
                    },
                    isFileValid: false,
                    isError: false,
                    errorMessage: "",
                    error: null,
                    isUploadForm: angular.isDefined(scope.template.templateId)
                        ? true
                        : false,
                    isChangedTemplateModel: false,
                    isChangedFileName: false,
                    customTemplate: {
                        isCustomTemplate: scope.isCustomTemplate ? true : false,
                        isCanBeEdited: false,
                    },
                    canEditDefault: eventSharingService.hasPermission(['admin:template:editdefault']),
                };
                console.log("templateService.userModel", scope.template);
                scope.reloadSelectedFile = function (file) {
                    //                console.log('$files', file)
                    angular.element("#templateUpload2").trigger("ng-file-change");
                };
                scope.onFileSelect = function ($files) {
                    if (!scope.viewModel.isUploadForm) {
                        scope.clearUploadingModel();
                    }
                    var alias = scope.viewModel.formModel.file
                        ? scope.viewModel.formModel.file.alias
                        : new Date().getTime() + ".tmp";
                    scope.viewModel.formModel.file = angular.isDefined($files[0])
                        ? $files[0]
                        : $files;
                    scope.viewModel.uploadingModel.isFileUploading = true;
                    if (!scope.viewModel.isUploadForm) {
                        scope.createFileName();
                        scope.createTemplateName();
                    }
                    scope.viewModel.formModel.file.alias = alias;
                    if (!scope.viewModel.isUploadForm) {
                        scope.checkFileExistence();
                    }
                    templateService
                        .uploadTemplateFile(scope.viewModel.formModel.file)
                        .progress(function (evt) {
                        scope.viewModel.uploadingModel.fileLoadProgress = parseInt((100.0 * evt.loaded) / evt.total);
                    })
                        .success(function (response, status, headers, config) {
                        scope.viewModel.uploadingModel.isFileUploading = false;
                        scope.viewModel.uploadingModel.isFileUloaded = true;
                        scope.checkIsFileValid();
                    })
                        .error(function (error) {
                        console.log("error", error);
                        scope.viewModel.isError = true;
                        scope.viewModel.errorMessage = "Error uploading the file!";
                        scope.viewModel.error = error.error.reason;
                        scope.viewModel.uploadingModel.isFileUploading = false;
                        //                    logger.debug('Upload failed for file!');
                    });
                };
                scope.setUserCustomTemplate = function () {
                    if (scope.viewModel.formModel.isUserCustomTemplate &&
                        templateService.model.currentUser) {
                        scope.viewModel.formModel.filePath =
                            templateService.model.currentUser +
                                "/" +
                                scope.viewModel.formModel.filePath;
                    }
                    if (!scope.viewModel.formModel.isUserCustomTemplate &&
                        templateService.model.currentUser) {
                        scope.viewModel.formModel.filePath =
                            scope.viewModel.formModel.filePath.replace(templateService.model.currentUser, "");
                    }
                    scope.viewModel.formModel.filePath =
                        scope.viewModel.formModel.filePath.replace(/\/{2,}/g, "/");
                    if (scope.viewModel.formModel.filePath.indexOf("/") === 0) {
                        scope.viewModel.formModel.filePath =
                            scope.viewModel.formModel.filePath.substr(1);
                    }
                    scope.createTemplateName();
                    scope.checkFileExistence();
                };
                scope.clearUploadingModel = function () {
                    scope.viewModel.uploadingModel.fileLoadProgress = 0;
                    scope.viewModel.uploadingModel.isFileUploading = false;
                    scope.viewModel.uploadingModel.isFileUloaded = false;
                    scope.viewModel.uploadingModel.isUploadError = false;
                    scope.viewModel.checkingModel.fileCheckProgress = 0;
                    scope.viewModel.checkingModel.isFileChecking = false;
                    scope.viewModel.isChangedFileName = false;
                    if (scope.viewModel.checkingModel.interval) {
                        $interval.cancel(scope.viewModel.checkingModel.interval);
                    }
                };
                scope.checkIsFileValid = function () {
                    scope.viewModel.checkingModel.isFileChecking = true;
                    templateService
                        .checkIsFileValid(scope.viewModel.formModel.file.alias)
                        .then(function (result) {
                        scope.viewModel.checkingModel.fileCheckProgress = 100;
                        scope.viewModel.isFileValid = true;
                        if (!scope.viewModel.customTemplate.isCustomTemplate) {
                            scope.viewModel.formModel.templateDefaultContent =
                                templateService.removePrefixTemplateFromModel(result.model);
                        }
                        scope.viewModel.formModel.imageModel = angular.isDefined(result.imageModel)
                            ? result.imageModel
                            : {};
                    }, function (err) {
                        scope.viewModel.isError = true;
                        scope.viewModel.errorMessage = "Template syntax error!";
                        scope.viewModel.error = err.error.reason
                            .replace("<", "&lt;")
                            .replace(">", "&gt;");
                        scope.viewModel.error +=
                            "<br><br>Please edit the template and upload again";
                        scope.viewModel.checkingModel.isFileChecking = false;
                        scope.removeTemplate();
                        scope.showError();
                    });
                };
                scope.registerTemplate = function () {
                    if ((scope.viewModel.isFileNameExist ||
                        scope.viewModel.isTemplateNameExist) &&
                        !scope.viewModel.customTemplate.isCustomTemplate) {
                        dialogs
                            .confirm("Confirm", "Selected template has been already registered! Are you sure you want to replace?")
                            .result.then(function () {
                            scope.confirmRegistration();
                        }, function () {
                            return;
                        });
                    }
                    else {
                        scope.confirmRegistration();
                    }
                };
                scope.confirmRegistration = function () {
                    var templateData = angular.copy(scope.viewModel.formModel);
                    templateData.userId = templateData.isMapToUser
                        ? templateService.userModel.userId
                        : null;
                    templateData.templateFileRef = angular.copy(templateData.filePath);
                    if (scope.viewModel.isUserCustomTemplate &&
                        (templateData.templateFileRef.indexOf(templateService.userModel.userId) !== 0 ||
                            templateData.templateFileRef.indexOf(templateService.userModel.userId) !== 1)) {
                        templateData.templateFileRef =
                            templateService.userModel.userId +
                                "/" +
                                templateData.templateFileRef;
                    }
                    templateData.mediaTypesJSON = JSON.stringify(templateData.mediaTypesJSON);
                    templateData.templateDefaultContent = scope.viewModel.formModel
                        .templateEditedModel
                        ? JSON.stringify(scope.viewModel.formModel.templateEditedModel)
                        : JSON.stringify(templateData.templateDefaultContent);
                    templateData.tmpFileName = templateData.file.alias;
                    delete templateData.file;
                    templateService
                        .registerTemplate(templateData, scope.viewModel.loadingIndicator)
                        .then(function (result) {
                        templateService.clonedTemplateModel = result.template;
                        scope.success();
                    }, function (errror) {
                        scope.viewModel.isError = true;
                        scope.viewModel.errorMessage = "Internal server error!";
                        scope.viewModel.error = angular.isDefined(error.error.reason)
                            ? error.error.reason
                            : "";
                        scope.viewModel.checkingModel.isFileChecking = false;
                    });
                };
                scope.replaceTemplate = function () {
                    var dataToRequest = {
                        tmpFileName: scope.viewModel.formModel.file.alias,
                        filePath: scope.viewModel.formModel.filePath,
                        templateId: scope.template.templateId,
                        templateFileRef: scope.template.templateFileRef,
                    };
                    templateService
                        .replaceTemplate(dataToRequest, scope.viewModel.loadingIndicator)
                        .then(function (result) {
                        console.log("replaceTemplate", result);
                        templateService.clonedTemplateModel = angular.copy(scope.template);
                        scope.success();
                    }, function (error) {
                        scope.viewModel.isError = true;
                        scope.viewModel.errorMessage = "Internal server error!";
                        scope.viewModel.error = angular.isDefined(error.error.reason)
                            ? error.error.reason
                            : "";
                        scope.viewModel.checkingModel.isFileChecking = false;
                    });
                };
                var _timeout = null;
                scope.templateNameIsChanged = function () {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        scope.checkFileExistence();
                    }, 1000);
                };
                scope.checkIfUsingDefaultFolder = function () {
                    if (scope.viewModel.formModel.filePath.indexOf("default") === 0 && !scope.viewModel.canEditDefault) {
                        scope.viewModel.errorMessage = "File path incorrect!";
                        dialogs.notify(scope.viewModel.errorMessage, 'You do not have access to add template in default folder');
                        scope.viewModel.formModel.filePath = '';
                    }
                };
                scope.setTemplateTypeFromCategory = function () {
                    var self = this;
                    var categoryId = self.viewModel.formModel.communicationsCategoryId;
                    var categories = templateService.availableCategorys;
                    var typeFromCategory = null;
                    for (let i = 0; i < categories.length; i++) {
                        if (categories[i].value === categoryId) {
                            typeFromCategory = categories[i].type;
                        }
                    }
                    self.viewModel.formModel.templateType = typeFromCategory;
                };
                scope.checkFileExistence = function () {
                    scope.setTemplateTypeFromCategory();
                    if (!angular.isDefined(scope.viewModel.formModel.filePath) ||
                        !angular.isDefined(scope.viewModel.formModel.templateName) ||
                        scope.viewModel.formModel.filePath.lastIndexOf("/") ===
                            scope.viewModel.formModel.filePath.length - 1 ||
                        (!scope.viewModel.customTemplate.isCustomTemplate &&
                            scope.viewModel.formModel.templateName.lastIndexOf("/") ===
                                scope.viewModel.formModel.templateName.length - 1)) {
                        return;
                    }
                    templateService
                        .checkFileExistence(scope.viewModel.formModel.filePath, scope.viewModel.formModel.templateName, scope.viewModel.formModel.communicationsCategoryId, scope.viewModel.formModel.language, scope.viewModel.loadingIndicator)
                        .then(function (result) {
                        scope.viewModel.isFileNameExist = result.isFileNameExist;
                        scope.viewModel.isTemplateNameExist =
                            result.isTemplateNameExist;
                        scope.viewModel.isTemplateAssignedToUser =
                            result.isTemplateAssignedToUser;
                    }, function (error) {
                        console.log("error", error);
                    });
                };
                if (templateService.userModel.userId) {
                    scope.viewModel.formModel.isMapToUser = true;
                    if (scope.viewModel.isUploadForm &&
                        !scope.viewModel.customTemplate.isCustomTemplate) {
                        if (scope.viewModel.formModel.filePath.indexOf(templateService.userModel.userId + "/") >= 0) {
                            scope.viewModel.formModel.isUserCustomTemplate = true;
                        }
                    }
                    else {
                        scope.viewModel.formModel.isUserCustomTemplate = true;
                        if (scope.viewModel.formModel.filePath.indexOf(templateService.userModel.userId + "/") < 0) {
                            scope.viewModel.formModel.filePath =
                                templateService.userModel.userId +
                                    "/" +
                                    scope.viewModel.formModel.filePath;
                        }
                    }
                    if (scope.viewModel.isUploadForm &&
                        scope.viewModel.customTemplate.isCustomTemplate) {
                        scope.checkFileExistence();
                    }
                }
                if (scope.viewModel.customTemplate.isCustomTemplate) {
                    scope.$watch("viewModel.isFileNameExist", function (newVal) {
                        if (newVal)
                            scope.viewModel.customTemplate.isCanBeEdited = true;
                    });
                    scope.$watch("viewModel.isTemplateNameExist", function (newVal) {
                        if (newVal)
                            scope.viewModel.customTemplate.isCanBeEdited = true;
                    });
                    scope.$watch("viewModel.isTemplateAssignedToUser", function (newVal) {
                        if (newVal)
                            scope.viewModel.customTemplate.isCanBeEdited = true;
                    });
                }
                scope.createFileName = function () {
                    scope.viewModel.formModel.filePath = angular.isDefined(scope.viewModel.formModel.filePath)
                        ? scope.viewModel.formModel.filePath.replace(scope.viewModel.prevFileName, "")
                        : "";
                    // If path does not end with / then add it at the end (typically assuming that the name starts with the userId)
                    if (scope.viewModel.formModel.filePath.lastIndexOf("/") + 1 !==
                        scope.viewModel.formModel.filePath.length) {
                        scope.viewModel.formModel.filePath += "/";
                    }
                    var tmpFileName = angular.copy(scope.viewModel.formModel.file.name);
                    var fileName = "";
                    if (scope.viewModel.formModel.file) {
                        fileName += scope.viewModel.formModel.file.name;
                    }
                    // Enforce naming convention to use lower case and replace spaces with -
                    fileName = fileName.toLowerCase();
                    fileName = fileName.replace(/\s{1,}/g, "-");
                    scope.viewModel.formModel.filePath += fileName;
                    scope.viewModel.prevFileName = fileName;
                    if (tmpFileName !== fileName) {
                        scope.viewModel.isChangedFileName = true;
                    }
                    console.log("createFileName", tmpFileName, "-----", fileName);
                };
                scope.createTemplateName = function () {
                    if (!angular.isDefined(scope.viewModel.formModel.filePath) ||
                        scope.viewModel.formModel.filePath === "") {
                        return;
                    }
                    var fileName = scope.viewModel.formModel.filePath;
                    console.log("fileName", fileName);
                    var templateName = fileName.lastIndexOf(".") !== -1
                        ? fileName.substr(0, fileName.lastIndexOf("."))
                        : fileName;
                    templateName = templateName.replace(/\/{1,}/g, "-");
                    scope.viewModel.formModel.templateName = templateName;
                };
                scope.fileNameIsMatched = function () {
                    if (!scope.viewModel.formModel.file) {
                        return true;
                    }
                    var loadedName = scope.viewModel.formModel.file.name;
                    // Enforce naming convention to use lower case and replace spaces with -
                    loadedName = loadedName.toLowerCase();
                    loadedName = loadedName.replace(/\s{1,}/g, "-");
                    var currentFileName = scope.viewModel.formModel.filePath;
                    // Get last part of path without any folders
                    currentFileName = currentFileName.substr(currentFileName.lastIndexOf("/") + 1, currentFileName.length);
                    if (currentFileName === loadedName) {
                        return true;
                    }
                    return false;
                };
                scope.isCanBeRegistered = function () {
                    if (!scope.viewModel.isFileValid ||
                        scope.viewModel.isTemplateNameExist) {
                        return false;
                    }
                    if (!scope.viewModel.formModel.file) {
                        return false;
                    }
                    if (scope.viewModel.formModel.templateName === "" ||
                        scope.viewModel.formModel.filePath === "") {
                        return false;
                    }
                    if (scope.viewModel.formModel.templateDisplayName === "" &&
                        !scope.viewModel.customTemplate.isCustomTemplate) {
                        return false;
                    }
                    // Check if the path includes any folders or only the filename
                    if (scope.viewModel.formModel.filePath.lastIndexOf("/") + 1 ===
                        scope.viewModel.formModel.filePath.length) {
                        return false;
                    }
                    return true;
                };
                scope.showError = function () {
                    var msg = scope.viewModel.error
                        ? scope.viewModel.error
                        : "Some sort of unexpected error!";
                    dialogs.notify(scope.viewModel.errorMessage, msg);
                };
                scope.editTemplateModelDialog = function () {
                    var template = false;
                    var templateId = angular.isDefined(scope.template.templateId)
                        ? scope.template.templateId
                        : false;
                    var fileModel = {
                        fileModel: scope.viewModel.formModel.templateDefaultContent,
                        alias: scope.viewModel.formModel.file.alias,
                        templateId: templateId,
                        imageModel: scope.viewModel.formModel.imageModel,
                        templateEditedModel: scope.viewModel.formModel.templateEditedModel,
                    };
                    // console.log('editTemplateModelDialog', template, fileModel)
                    scope.templateService
                        .editTemplateModelDialog(template, fileModel)
                        .then(function (data) {
                        if (angular.isObject(data.result)) {
                            scope.viewModel.formModel.templateEditedModel = data.result;
                            scope.viewModel.isChangedTemplateModel = true;
                        }
                        if (data.sourceWasChanged) {
                            scope.checkIsFileValid();
                        }
                    })
                        .catch(function (data) {
                        if (data.sourceWasChanged) {
                            scope.checkIsFileValid();
                        }
                    });
                };
                scope.openTemplateNamingDialog = function () {
                    scope.templateService.fileNameGuideDialog();
                };
                scope.removeTemplate = function () {
                    if (!scope.viewModel.formModel.file ||
                        !angular.isDefined(scope.viewModel.formModel.file.alias)) {
                        return;
                    }
                    scope.templateService.cancelUploadTemplateFile(scope.viewModel.formModel.file.alias, true);
                };
                scope.closeUploadDialog = function () {
                    if (!scope.viewModel.formModel.file) {
                        scope.cancel();
                        return;
                    }
                    scope.cancel();
                };
                var windowElement = angular.element($window);
                windowElement.on("beforeunload", function (event) {
                    scope.removeTemplate();
                });
                scope.$on("$destroy", function () {
                    windowElement.off("beforeunload");
                    scope.removeTemplate();
                });
            },
        };
    },
]);
//# sourceMappingURL=templates-upload.directive.js.map